<div class="page main-signin-wrapper">

    <!-- Row -->
    <div class="row signpages overflow-hidden">
            <div class="col-sm-12 col-lg-5 d-none d-lg-flex details px-4">
              <div class="position-relative m-auto">
                <img class="" src="../../assets/img/brand/logoWhite.svg" alt="">
                <span class="d-block text-white mt-3 text-center op-8">¡Bienvenido!</span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-lg-7 login_form ">
                  <div class="card-body mt-2 mb-2">
                    <div class="row">
                      <div class="col-sm-12">
                        <img src="../../assets/img/brand/logo.svg" class="d-lg-none header-brand-img mb-4 w-100" alt="logo">
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <form [formGroup]="loginForm" novalidate>
                      <div class="row">
                        <div class="col-12">
                          <h4 class="text-left mb-1">Iniciar sesión</h4>
                          <p class="mb-4 text-muted tx-13 ml-0 text-left">Ingresa al administrador de <b class="text-primary">TASKIN</b>.</p>
                          <ngb-alert type="primary" [dismissible]="true" *ngIf="expiredSesionAlert">
                            <span class="alert-inner--text">Sesión expirada</span>
                          </ngb-alert>
                          <ngb-alert type="danger" [dismissible]="true" *ngIf="invalidCredentials">
                            <span class="alert-inner--text">Credenciales Invalidas</span>
                          </ngb-alert>
                          
                        </div>
                      </div>
 
                      <div class="row">
                        <div class="col-12">
                          <h6>Usuario</h6>
                          <input class="form-control mb-3" formControlName="username" type="text" placeholder="Ingresa nombre de usuario">
                          <div
                            *ngIf="(loginFormControl.username.touched || submitted) && (loginFormControl.username.errors?.required)"
                            class="tx-danger">
                            <small>Por favor, ingresa tu usuario</small>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-8">
                          <h6>Contraseña</h6>
                          <input class="form-control mb-2" formControlName="password" type="password" placeholder="Ingresa Contraseña">
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4">
                          <h6>NIP</h6>
                          <input class="form-control mb-2" formControlName="nip" type="password" placeholder="****">
                        </div>
                        <div class="col-12 mb-2">
                          <ng-container *ngIf="((loginFormControl.password.touched || submitted) && (loginFormControl.password.errors?.required)) || ((loginFormControl.nip.touched || submitted) && (loginFormControl.nip.errors?.required))">
                            <small class="text-danger">Por favor, ingresa tu
                              <b *ngIf="(loginFormControl.password.touched || submitted) && (loginFormControl.password.errors?.required)">contraseña</b>
                              <span class="mx-1" *ngIf="((loginFormControl.password.touched || submitted) && (loginFormControl.password.errors?.required)) && ((loginFormControl.nip.touched || submitted) && (loginFormControl.nip.errors?.required))">y</span>
                              <b *ngIf="(loginFormControl.nip.touched || submitted) && (loginFormControl.nip.errors?.required)">NIP</b></small>
                          </ng-container>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6 pr-5 d-none d-lg-flex">
                          <img src="../../assets/img/brand/logoFeedbak.svg" class="img-responsive my-auto">
                        </div>
   
                        <div class="col-sm-12 col-lg-6 pl-lg-0">
   
                        <button class="btn ripple btn-primary btn-block" type="submit"  (click)="Submit()"  [disabled]="!loginForm.valid">Ingresar</button>
                        </div>
                        <div class="col-sm-12 d-flex d-lg-none pt-4">
                          <img src="../../assets/img/brand/logoFeedbak.svg" style="width: 120px;" class="img-responsive mx-auto">
                        </div>
                      </div>
                    </form>
                  </div>
                
            </div>
  
    </div>
    <!-- End Row -->
  
  </div>

  <ng-template #modalCredentials let-modal>
    <credentials-modal (onClose)="modal.close();" (onConfirm)="updateCredentials();"></credentials-modal>
  </ng-template>
  